import blank from '@cordel/helpers/form/validators/blank';
import cellphone from '@cordel/helpers/form/validators/cellphone';
import cellphoneNumber from '@cordel/helpers/form/validators/cellphone-number';
import chassis from '@cordel/helpers/form/validators/chassis';
import cnpj from '@cordel/helpers/form/validators/cnpj';
import cpf from '@cordel/helpers/form/validators/cpf';
import cpfOrCnpj from '@cordel/helpers/form/validators/cpf-or-cnpj';
import custom from '@cordel/helpers/form/validators/custom';
import date from '@cordel/helpers/form/validators/date';
import digit from '@cordel/helpers/form/validators/digit';
import equalTo from '@cordel/helpers/form/validators/equal-to';
import email from '@cordel/helpers/form/validators/email';
import exists from '@cordel/helpers/form/validators/exists';
import greaterThan from '@cordel/helpers/form/validators/greater-than';
import fn from '@cordel/helpers/form/validators/fn';
import greaterThanOrEqualTo from '@cordel/helpers/form/validators/greater-than-or-equal-to';
import inclusion from '@cordel/helpers/form/validators/inclusion';
import invalid from '@cordel/helpers/form/validators/invalid';
import requiredLegalAge from '@cordel/helpers/form/validators/required-legal-age';
import lessThan from '@cordel/helpers/form/validators/less-than';
import lessThanOrEqualTo from '@cordel/helpers/form/validators/less-than-or-equal-to';
import notANumber from '@cordel/helpers/form/validators/not-a-number';
import notEqualTo from '@cordel/helpers/form/validators/not-equal-to';
import phone from '@cordel/helpers/form/validators/phone';
import phoneCode from '@cordel/helpers/form/validators/phone-code';
import phoneNumber from '@cordel/helpers/form/validators/phone-number';
import plate from '@cordel/helpers/form/validators/plate';
import renavam from '@cordel/helpers/form/validators/renavam';
import tooLarge from '@cordel/helpers/form/validators/too-large';
import tooShort from '@cordel/helpers/form/validators/too-short';
import unique from '@cordel/helpers/form/validators/unique';
import zip from '@cordel/helpers/form/validators/zip';

const validators = {
  blank,
  cellphone,
  cellphoneNumber,
  chassis,
  custom,
  cnpj,
  cpf,
  cpfOrCnpj,
  date,
  digit,
  equalTo,
  email,
  exists,
  fn,
  greaterThan,
  greaterThanOrEqualTo,
  inclusion,
  invalid,
  requiredLegalAge,
  lessThan,
  lessThanOrEqualTo,
  notANumber,
  notEqualTo,
  phone,
  phoneCode,
  phoneNumber,
  plate,
  renavam,
  tooLarge,
  tooShort,
  unique,
  zip,
};

function cammelCase(validator) {
  return validator.replace(/[A-Z]/g, i => `_${i}`).toLowerCase();
}

// credere's api validators normalizer
Object.keys(validators).forEach((validator) => {
  validators[cammelCase(validator)] = validators[validator];
});

export default validators;
